import { observer } from 'mobx-react';
import { humanizeString } from 'Mri.Web.Common';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';

export enum UserRoleViews {
    Portal = 'portal',
    Production = 'production',
    Admin = 'admin',
    All = 'all',
}

export interface IUserRoleViewSelectorProps {
    readonly className?: string;
    readonly baseUrl: string;
    readonly userRoleView: UserRoleViews;
}

@observer
export class UserRoleViewSelector extends React.Component<IUserRoleViewSelectorProps> {
    public render() {
        const { userRoleView, className, baseUrl } = this.props;
        return (
            <UncontrolledButtonDropdown className={className}>
                <DropdownToggle caret>{humanizeString(userRoleView)}</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem tag={Link} to={`${baseUrl}/${UserRoleViews.All}`}>
                        All
                    </DropdownItem>
                    <DropdownItem tag={Link} to={`${baseUrl}/${UserRoleViews.Portal}`}>
                        Portal
                    </DropdownItem>
                    <DropdownItem tag={Link} to={`${baseUrl}/${UserRoleViews.Production}`}>
                        Production
                    </DropdownItem>
                    <DropdownItem tag={Link} to={`${baseUrl}/${UserRoleViews.Admin}`}>
                        Admins
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }
}
